import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=75f807aa&scoped=true"
import script from "./ScrollList.vue?vue&type=script&lang=js"
export * from "./ScrollList.vue?vue&type=script&lang=js"
import style0 from "./ScrollList.vue?vue&type=style&index=0&id=75f807aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f807aa",
  null
  
)

export default component.exports